import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Moment from "react-moment";
import { FiMoreHorizontal } from "react-icons/fi";
import { Dropdown, Row, Col, FormGroup, FormControl } from "react-bootstrap";
import EmployeeListItemHeader from "components/Employees/EmployeeListItemHeader";
import AbsenceListItemPeriod from "components/Absences/AbsenceListItemPeriod";
import * as employeesActions from "actions/employeesActions";
import * as workflowsActions from "actions/workflowsActions";
import { workflowsService } from "services";
import { wfStatus } from "services/workflowsService";
import { errorFormating } from "utils/utils";

class PendingPreferencesList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			answersById: {},
		};
	}

	componentDidUpdate(prevProps) {
		// Keep existing answers when list changes; no need to mirror props into state
	}

	async handlePreferenceStatus(preference, isApproved) {
		let status = wfStatus.approved;

		if (!isApproved) {
			status = wfStatus.denied;
		} else {
			// Lógica de aprobación de dos niveles
			const currentUser = this.props.user;

			// Verificar que tenemos la información necesaria
			if (
				currentUser &&
				currentUser.groups_supervised &&
				preference.requester &&
				preference.requester.employee_with_group &&
				preference.requester.employee_with_group.group
			) {
				const workflowGroup = preference.requester.employee_with_group.group;

				// Si el estado actual es "Pendiente aprobación segundo nivel", pasa directamente a "Aprobado"
				if (preference.status === wfStatus.pendingSecondLevel) {
					status = wfStatus.approved;
				}
				// Si el estado es "Pendiente" y el grupo tiene two_levels_workflow activo
				else if (
					preference.status === wfStatus.pending &&
					workflowGroup.two_levels_workflow
				) {
					// Siempre pasa a segundo nivel cuando el grupo tiene two_levels_workflow activo
					status = wfStatus.pendingSecondLevel;
				}
				// En cualquier otro caso, mantiene "Aprobado"
			}
		}

		// Apply local answer comment, if any
		const localAnswer = this.state.answersById[preference.id];
		if (localAnswer !== undefined) {
			preference.answer_comments = localAnswer;
		}

		preference.shift_id = preference.shift.id;
		preference.status = status;

		// console.log(preference)

		const response = await workflowsService.update(preference);
		// console.log(response);

		if (response.ok) {
			toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));

			await this.props.reloadPreferences();
			// Clean local answer once updated
			this.setState((prev) => {
				const next = { ...prev.answersById };
				delete next[preference.id];
				return { answersById: next };
			});
		} else {
			let textError = errorFormating(response);
			this.props.openAlertModal(
				textError.general,
				this.props.t("preferences.errorManage")
			);
		}
	}

	handleChange = (event, preference) => {
		const value = event.target.value;
		this.setState((prev) => ({
			answersById: { ...prev.answersById, [preference.id]: value },
		}));
	};

	getEmptyRow = () => {
		return (
			<p className="no-results">
				{this.props.t("preferences.noPendingSupervision")}
			</p>
		);
	};

	getRows = () =>
		this.props.pending_preferences.map((preference) => (
			<div className="col-sm-6 col-lg-4 col-xl-3" key={preference.id}>
				<article className="card card-ausencia" key={preference.id}>
					<EmployeeListItemHeader employee={preference.requester} />

					<div className="card-content">
						<span className="preference-comments">{preference.comments}</span>

						<span
							className="card-shift"
							style={{
								backgroundColor:
									preference.shift.background_color &&
									preference.shift.background_color,
								borderColor:
									preference.shift.border_color &&
									preference.shift.border_color,
							}}
						>
							{preference.shift.name}
						</span>

						<AbsenceListItemPeriod absence={preference} />

						<FormGroup className="form-group mt25" controlId="answer_comments">
							{/* <FormLabel>Comentarios</FormLabel> */}
							<FormControl
								as="textarea"
								value={
									this.state.answersById[preference.id] !== undefined
										? this.state.answersById[preference.id]
										: preference.answer_comments
								}
								onChange={(e) => this.handleChange(e, preference)}
								className="answer-comments"
								placeholder={this.props.t("preferences.answerPlaceholder")}
							/>
						</FormGroup>

						<Row className="row-buttons">
							<Col sm={6}>
								<button
									type="button"
									className="btn btn-primary"
									onClick={() => this.handlePreferenceStatus(preference, true)}
								>
									{this.props.t("preferences.approve")}
								</button>
							</Col>
							<Col sm={6}>
								<button
									type="button"
									className="btn btn-secondary"
									onClick={() => this.handlePreferenceStatus(preference, false)}
								>
									{this.props.t("preferences.deny")}
								</button>
							</Col>
						</Row>

						<p className="card-label card-label-solicitado">
							{this.props.t("preferences.requestedOn")}{" "}
							<Moment className="tag-dia" format="D/MM/YYYY">
								{preference.requested}
							</Moment>
						</p>
					</div>

					{preference.status === wfStatus.pending && (
						<div className="card-actions bottom-right">
							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() =>
											this.props.openEditPreferenceModal(preference)
										}
									>
										{this.props.t("common.edit")}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					)}
				</article>
			</div>
		));

	render() {
		// console.log(this.props.pending_preferences.length);
		return (
			<>
				{this.props.pending_preferences.length === 0 ? (
					this.getEmptyRow()
				) : (
					<div className="row list-preferences">{this.getRows()}</div>
				)}
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		// ...reducers.workflowsReducer, // Managed by parent
		user: reducers.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getEmployeePreferences: (employee_id) =>
		dispatch(employeesActions.getEmployeePreferences(employee_id)),
	getPendingPreferences: (options) =>
		dispatch(workflowsActions.getPendingPreferences(options)), // Managed by parent
	getManagedPreferences: (options) =>
		dispatch(workflowsActions.getManagedPreferences(options)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(PendingPreferencesList));
